import { Box, Button, Heading, Image, Stack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const CategoryItem = ({ item }) => {
  return (
    <Box position={'relative'} h={['40vh', '40vh', '50vh', '60vh']}>
      <Image
        rounded="lg"
        w="full"
        h="full"
        objectFit={'cover'}
        src={item.img}
      />
      <Stack
        pos="absolute"
        w="full"
        h="full"
        top="0"
        left="0"
        alignItems={'center'}
        justifyContent="center"
      >
        <Heading
          as="h3"
          textAlign="center"
          fontSize="20px"
          color="teal"
          bg="white"
          mb="20px"
          p="10px"
        >
          {item.title}
        </Heading>
        <Button colorScheme={'teal'}>
          <Link to="/products">Shop Now</Link>
        </Button>
      </Stack>
    </Box>
  );
};

export default CategoryItem;
